import { createContext, useContext } from "react";
import type { SelectedFiltersInput } from "@/lib/utils/filters";

/**
 * Context value when SOV is rendered under TanStack Router.
 * URL search params are the source of truth; this provides dates and filter AND shape
 * so subscription and metrics table hooks can use them without reading from the store.
 */
export interface ShareOfVoiceParamsContextValue {
  startDate: string;
  endDate: string;
  filtersAnd: SelectedFiltersInput;
}

const ShareOfVoiceParamsContext =
  createContext<ShareOfVoiceParamsContextValue | null>(null);

export const ShareOfVoiceParamsProvider = ShareOfVoiceParamsContext.Provider;

/**
 * Requires {@link ShareOfVoiceParamsProvider} (TanStack Share of Voice route).
 */
export const useShareOfVoiceParamsContextRequired =
  (): ShareOfVoiceParamsContextValue => {
    const value = useContext(ShareOfVoiceParamsContext);
    if (!value) {
      throw new Error(
        "useShareOfVoiceParamsContextRequired must be used within ShareOfVoiceParamsProvider",
      );
    }
    return value;
  };
